export const versions = {
  version: "1.0.183",
  revision: "172c8ca51",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-4880-g172c8ca51-dirty",
    hash: "g172c8ca51",
    distance: 4880,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "4880-g172c8ca51-dirty",
    semverString: "1.0.183+4880.g172c8ca51.dirty"
  }
};
